import React from 'react';
import PropTypes from 'prop-types';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

import toJS from 'appDir/lib/hocs/toJS';

export const drawerOpenWidth = 240;
export const drawerClosedWidth = 64;
const drawerBackgroundColor = '#dedede';

const styles = theme => ({
  root: {
    display: 'flex',
  },
  drawer: {
    width: drawerOpenWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  drawerOpen: {
    width: drawerOpenWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    backgroundColor: drawerBackgroundColor,
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: drawerClosedWidth,
    backgroundColor: drawerBackgroundColor,
  },
  link: {
    textDecoration: 'none',
    color: 'black',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  tooltip: {
    fontSize: 14,
  },
  whiteColor: {
    color: '#fff',
  },
});

const JWAdminLayoutSidenav = ({ classes }) => {
  const [open, setOpen] = React.useState(true);

  return (
    <div className={classes.root}>
      <Drawer
        variant="permanent"
        className={classNames(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: classNames({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
        style={{ zIndex: 1299 }}
        open={open}
      >
        <div className={classes.toolbar}>
          <IconButton onClick={() => setOpen(!open)}>{open ? <ChevronLeftIcon /> : <ChevronRightIcon />}</IconButton>
        </div>
        <Divider />
        <List>
          <ListItem component="a" href="/jwadmin/dashboard" className={classes.link}>
            <ListItemText primary="Dashboard" />
          </ListItem>
          <ListItem component="a" href="/jwadmin/organizations" className={classes.link}>
            <ListItemText primary="Organizations" />
          </ListItem>
          <ListItem component="a" href="/jwadmin/stripe/scheduled_plan_changes" className={classes.link}>
            <ListItemText primary="Stripe - Plan Changes" />
          </ListItem>
          <ListItem component="a" href="/jwadmin/scheduled_announcements" className={classes.link}>
            <ListItemText primary="Scheduled Announcements" />
          </ListItem>
          <ListItem component="a" href="/jwadmin/users" className={classes.link}>
            <ListItemText primary="Users" />
          </ListItem>
          <ListItem component="a" href="/jwadmin/users/current_logins/organizers" className={classes.link}>
            <ListItemText primary="Currently Logged In" />
          </ListItem>
          <ListItem component="a" href="/jwadmin/redirects" className={classes.link}>
            <ListItemText primary="Redirects" />
          </ListItem>
          <ListItem component="a" href="/jwadmin/orgsmap" className={classes.link}>
            <ListItemText primary="Organizations Map" />
          </ListItem>
          {/* <ListItem
            component="a"
            href="/jwadmin/credit_card_descriptor_auditor"
            className={classes.link}
          >
            <ListItemText primary="Descriptor Auditor" />
          </ListItem> */}
        </List>
      </Drawer>
    </div>
  );
};

JWAdminLayoutSidenav.propTypes = {
  classes: PropTypes.object.isRequired,
};
JWAdminLayoutSidenav.defaultProps = {};

export default toJS(withStyles(styles)(JWAdminLayoutSidenav));
